export default __webpack_public_path__ + "static/media/logo_extended_dark.aa29614a.png";